import { VEHICLE_STATUS_LIST, VEHICLE_STATUS_LIST_SUCCESS, VEHICLE_STATUS_LIST_ERROR } from './constants';
import { VEHICLE_STATUS_DETAILS, VEHICLE_STATUS_DETAILS_SUCCESS, VEHICLE_STATUS_DETAILS_ERROR } from './constants';
import { ADD_VEHICLE_STATUS_DETAILS, ADD_VEHICLE_STATUS_DETAILS_SUCCESS, ADD_VEHICLE_STATUS_DETAILS_ERROR } from './constants';
import { UPDATE_VEHICLE_STATUS, UPDATE_VEHICLE_STATUS_SUCCESS, UPDATE_VEHICLE_STATUS_ERROR } from './constants';
import { DELETE_VEHICLE_STATUS, DELETE_VEHICLE_STATUS_SUCCESS, DELETE_VEHICLE_STATUS_ERROR } from './constants';
import { ASSIGN_USERS_LIST, ASSIGN_USERS_LIST_SUCCESS, ASSIGN_USERS_LIST_ERROR } from './constants';
export default function vehiclestatusReducer(state, action) {
	let vehiclestatus = [];
	let  users = [];

	switch (action.type) {
	case VEHICLE_STATUS_LIST:
		return { ...state, pending: true };
      
	case VEHICLE_STATUS_LIST_SUCCESS:
        
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
            
				let data = {};

				data.id = item.id ? item.id : 0;
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.name = item.name ? item.name : '';
				data.vehicleNumber = item.vehicleNumber ? item.vehicleNumber : '';
				data.travelledDistance = item.travelledDistance ? item.travelledDistance : 0;
				data.assignedUserId = item.assignedUserId ? item.assignedUserId : '';
				data.assignedUser = item.users ? item.users.firstName + ' ' + item.users.lastName : 'No Data' ;
				data.allocationId = item.allocationId ? item.allocationId : '';
				data.status = item.status ? item.status : '';
				data.batteryVoltage = item.batteryVoltage ? item.batteryVoltage : 0;
				data.imeiNumber = item.imeiNumber ? item.imeiNumber : '';
				data.allocation = item?.userallocation ? item?.userallocation  && Array.isArray(item?.userallocation) ?  item?.userallocation.map((region)=>(region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')')) : `${item?.userallocation?.regioninfo.regionName+'(' + item?.userallocation?.pipelineConfigFrom+' - '+item?.userallocation?.pipelineConfigTo + ')'}` : 'No Data';
				data.simNumber = item?.simNumber? item?.simNumber : ''; 
				data.gsmStrength = item?.gsmStrength? item?.gsmStrength : null;


				return vehiclestatus.push(data);
			});
          
			return { ...state, vehiclestatus: vehiclestatus, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, vehiclestatus: vehiclestatus, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case VEHICLE_STATUS_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case VEHICLE_STATUS_DETAILS:
		return { ...state, pending: true };

	case VEHICLE_STATUS_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case VEHICLE_STATUS_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_VEHICLE_STATUS_DETAILS:
		return { ...state, pending: false };

	case ADD_VEHICLE_STATUS_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_VEHICLE_STATUS_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_VEHICLE_STATUS:
		return { ...state, pending: false };

	case UPDATE_VEHICLE_STATUS_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_VEHICLE_STATUS_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_VEHICLE_STATUS:
		return { ...state, pending: false };

	case DELETE_VEHICLE_STATUS_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_VEHICLE_STATUS_ERROR:
		return { ...state, pending: false, error: true };

	case ASSIGN_USERS_LIST:
		return { ...state, pending: true };
      
	case ASSIGN_USERS_LIST_SUCCESS:
        
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
            
				let data = {};

				data.value = item.id ? item.id : 0;
				data.label = item.firstName + ' ' + item.lastName;



				return users.push(data);
			});
          
			return { ...state, users : users, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, users : users , pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case ASSIGN_USERS_LIST_ERROR:
		return { ...state, pending: false, error: true };

	

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}